// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = require('react');
const classNames = require('classnames');

class RATag extends Component {
    render() {
        const { type, emphasis, context, content } = this.props;
        let nonIdentificationContext = context === 'arrow' && emphasis ? 'arrow-emphasis' : context;
        const contextClassName = type === 'identification' ? 'pill' : nonIdentificationContext;
        const classNameComponent = classNames(`ra-tag`, `ra-tag__${type}`, {
            [`ra-tag__${type}--${contextClassName}`]: context,
            [`ra-tag__${type}--emphasis`]: emphasis,
        });
        let text = content;

        if (typeof content === 'string') {
            text = <span className="ra-tag__content">{content}</span>;
        }

        return <div className={classNameComponent}>{text}</div>;
    }
}

RATag.propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    context: PropTypes.oneOf(['square', 'arrow', 'pill', 'flap', 'layered', 'transparent', 'no-container']),
    emphasis: PropTypes.bool,
    type: PropTypes.oneOf([
        'identification',
        'new',
        'action',
        'success',
        'pending',
        'warning',
        'informative',
        'disabled',
    ]),
};

RATag.defaultProps = {
    context: 'square',
    emphasis: false,
    type: 'informative',
};

module.exports = RATag;
